"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.textCell = void 0;
const Grid_1 = require("../../Grid");
function textCell(config) {
    return (rowData, payload) => {
        return (0, Grid_1.textCellRenderer)(Object.assign(Object.assign({}, payload), { cellData: config.value(rowData) }));
    };
}
exports.textCell = textCell;
//# sourceMappingURL=textCell.js.map